import * as d3 from 'd3'
export default {
  methods: {

    open_Popup(selection, props, type, msg, newData, stg, target) {

      let msgGroup = selection
      .append('g')
      .attr('id', `MESSAGE`)
      .attr('transform', `translate(0, 0)`)

      msgGroup
      .append('rect')
      .attr('id', `MSG_BACKGROUND`)
      .attr('rx', 10).attr('ry', 10).attr('width', props.width).attr('height', props.height).attr('fill', '#fff').attr('opacity', .8)


      if(type=='Alert') this.msg_Alert(msgGroup, msg)
      if(type=='Confirm') this.msg_Confirm(msgGroup, newData, stg, target)
      if(type=='Success') this.msg_Success(msgGroup, msg)
    },


    msg_Alert(selection, msg) {

      let message = selection
      .append('g')
      .attr('transform', `translate(300, 200)`)

      message
      .append('rect')
      .attr('x', 2).attr('y', 2)
      .attr('width', 354).attr('height', 168).attr('rx', 5).attr('ry', 5)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', 0)
      .attr('filter', 'url(#msgShadow)').style('opacity', .3)

      message
      .append('image')
      .attr('x', 0).attr('y', 0)
      .attr('xlink:href', this.HOST + `/Database/popup/Alert.svg`).attr('height', 172)

      let y_ = 0
      let msgList = message
      .append('g')
      .attr('transform', `translate(100, 72)`)

      msg.forEach(d=> {
        msgList
        .append('text')
        .attr('y', y_).attr('fill', '#333').attr('font-size', 13)
        .text(d)
        y_ += 18
      })

      // Cancel
      message 
      .append('image').attr('cursor', 'pointer')
      .attr('xlink:href', this.HOST + `/Database/btn/Cancel.svg`).attr('x', 260).attr('y', 130).attr('width', 80)
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        d3.select(`#MESSAGE`).remove()
      })
    },



    msg_Confirm(selection, newData, stg, target) {
      let message = selection
      .append('g')
      .attr('transform', `translate(300, 200)`)

      message
      .append('rect')
      .attr('x', 2).attr('y', 2)
      .attr('width', 354).attr('height', 168).attr('rx', 5).attr('ry', 5)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', 0)
      .attr('filter', 'url(#msgShadow)').style('opacity', .3)

      message
      .append('image')
      .attr('x', 0).attr('y', 0)
      .attr('xlink:href', this.HOST + `/Database/popup/Confirm.svg`).attr('height', 172)

      // Ok
      message 
      .append('image').attr('cursor', 'pointer')
      .attr('xlink:href', this.HOST + `/Database/btn/Ok_Blue.svg`).attr('x', 170).attr('y', 130).attr('width', 80)
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        d3.select(`#MESSAGE`).remove()
        this.save_DataList(newData, stg, target)
      })

      // Cancel
      message 
      .append('image').attr('cursor', 'pointer')
      .attr('xlink:href', this.HOST + `/Database/btn/Cancel.svg`).attr('x', 260).attr('y', 130).attr('width', 80)
      .on('mouseover', function() { d3.select(this).transition().duration(75).style('opacity', .5) })
      .on('mouseout', function() { d3.select(this).transition().duration(250).style('opacity', 1) })
      .on('click', () => {
        d3.select(`#MESSAGE`).remove()
      })
    },


  }
}